/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';
import './animation018.less';

interface IAnimation018Item {
  icon: string;
  text: string;
}

interface IAnimation018Props {
  items: IAnimation018Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation018: React.FunctionComponent<IAnimation018Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      onCompleted && onCompleted();
    }
  };

  React.useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };

  return (
    <div ref={crrRef} className={`animation018 component ${className || ''}`}>
      {items.map((itm: IAnimation018Item, idx: number) => (
        <div key={idx} className="animation018-contaner">
          <div
            onClick={() => clickToPlay()}
            className={`animation018-item r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <img
              className="click-point1"
              onClick={() => clickToPlay()}
              style={{
                display: play <= 1 ? 'block' : 'none',
              }}
              src={ImgPoint}
              alt=""
            />
            <div className="icon">
              <img
                src={require(`../../../../../assets/${itm.icon}`).default}
                alt=""
              />
            </div>
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Animation018;
